import { render, staticRenderFns } from "./activitySchedule.vue?vue&type=template&id=5387322d&scoped=true&"
import script from "./activitySchedule.vue?vue&type=script&lang=js&"
export * from "./activitySchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387322d",
  null
  
)

export default component.exports